<template>
	<div class="factor-item-selectable" :class="{selected}" @click="$emit('click', factor)">
		<check-icon-filled :disabled="!selected" class="check-icon" color="secondary" />
		<div class="factor-item-selectable-content tw-flex tw-justify-start tw-items-center">
			<div>
				<img class="content-image" :src="factor.urlImage"  alt="" />
				<p class="tw-m-0 text-info uppercase content-name">{{ factor.name }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import CheckIconFilled from '@/modules/shared/components/icons/check-icon-filled';

export default {
	name: 'FactorItemSelectable',
	components: { CheckIconFilled },
	props: ['factor', 'selected'],
};
</script>

<style lang="scss" scoped>
.factor-item-selectable {
	border-radius: 10px;
	box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
	border: solid 2px var(--app-color-gray);
	background-color: #ffffff;
	padding-bottom: 90%;
	position: relative;
	user-select: none;
	.check-icon {
		position: absolute;
		top: 10px;
		right: 10px;
	}
	.factor-item-selectable-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		padding: 20px;
		cursor: pointer;
		.content-name {
			border-top: 1px solid var(--app-color-secondary);
			width: 70%;
			padding-top: 5px;
			line-height: 16px;
			font-size: 12px;
			min-height: 40px;
		}
		.content-image {
			width: 35px;
			height: 35px;
		}
	}
	&.selected {
		border: solid 2px var(--app-color-secondary);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/FactorItemSelectable.vue